
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Admission Overview</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg">
    <div class="container">
        <div class="row ">
            <div class="col-md-12">
                <div class="inner-title"  >
                    <h3>Admission Overview</h3>							
                   
                </div>
            </div>
            <div class="col-md-7">
                <div class="text-justify" >
                    <p>As a Raisonian you will initiate your path of learning, imbibe knowledge and inculcate skill sets at our institutes. You will start with a journey embellished with state-of-the-art tools, guidance of the finest faculty and infrastructure which is promising. An environment which lets you grow, seek questions and ingest insightful answers. You will be introduced to the real world through industry tie ups. You will be conveyed the norms of the competition outside with the regularly updated curriculum. You will be presented to versatility in activities assuring an all round development with us.</p>
                    <p>Our institutes have a vision that would aid you in carving a niche in your successful ventures. They are an embodiment of education that involves value based education, state-of-the-art infrastructure, and a plethora of amenities. They are the reflection of knowledge that ensures you become independent, strong and capable. They are the key to the first step of a journey of milestones. After all, it is a system which has been designed by the most acclaimed academicians and the masters from all walks of life</p>
                    <ul class="list-item">
                        <li>We have more than 25,000+ students studying in our schools, colleges and universities sprawling central India -in the cities of Nagpur, Pune, Ahmednagar, Chhindwara, Jalgaon, Amravati and Raipur.</li>
                        <li>We have more than 45,000 alumni, which belong to the RGI family. Our alumni work in some of the top notch companies, institutes and organization in India and outside. Our students are still a part of our family.Once a Raisonian, always a Raisonian!</li>
                        <li>We have 2 universities which boast of the excellence we are a part of</li>
                    </ul>                     
                    <p>You are never alone in any endeavor when you study in our institute. We have students who continue to come back to us to thank us, applaud us or ask for guidance. It is the trust they have in their faculty and educators which paves the way for them. You will receive strength and guidance throughout your journey with us.</p>
                    <blockquote>So, come join the journey where success is not a part of life, success is being a Raisonian!</blockquote>
                </div>
            </div>
            <div class="col-md-5">
                <div class="text-center team" >
                    <figure class="mb-0"><img src="assets/images/admission-overview.webp" alt="Admission Overview | Ghrcacsn" title="Admission Overview | Ghrcacsn"></figure>
                </div>
            </div>
        </div>
    </div>
</section>

